import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Left from '../layout/Left';
import  { Redirect } from 'react-router-dom'



import MainLayout from "../layout/main-layout";
// import Top from "../layout/Top";
import Header from "../layout/Header";

class Congratulations extends Component {
    render() {
        //const {paymentInfo} = this.state
        if(!sessionStorage.getItem('client_id') || sessionStorage.getItem('client_id')==null) {
           
            return <Redirect to="../" />
          }
        return (
            <MainLayout>
                <Header />
               
                <div className="main-content">
                 
                    <Left activeMenu={"resources"}/>
                    
                    <div class="right-section">
                    <div class="pagesubheader-wrap">
                        <div class="pagesubheader-row">
                            <div class="page-subheader-col-left">
                                <div class="title-avatar">
                                    <img src="images/credit-card.svg" alt="" />
                                </div>
                                <div class="title-main">
                                    <span class="title-sub-text">Client Portal</span>
                                    <h1>Resources</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                        <div className="inner-content-area"> 
                            <ul>
                                <li><a  target="_blank" href="https://vimeo.com/957259315">Inside American Cell Technology: A Behind-the-Scenes Look </a></li>
                                <li> <a href="https://vimeo.com/1096692690?share=copy&fl=sv&fe=ci" target="_blank">Intro to ACT's Prepaid Annual Storage & Bio-Insurance Plans</a></li>
                                <li> <a target="_blank" href="../Annual 2.jpeg">Annual Storage Plan Options</a></li>
                                <li> <a target="_blank" href="../Bio 2.png">Bio-Insurance Plan Options </a></li>

                                
                            </ul>
                        </div>                     


                    </div>

                </div>
            </MainLayout>
        );
    }
}

Congratulations.propTypes = {

};

export default Congratulations;